class WaitlistModal extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector('#closeWaitmodal')
    this.form = this.querySelector('#collection-waitlist')

    this.init();
  }

  init() {
   this.bindEvents();
  }

  bindEvents() {
    this.closeBtn.addEventListener("click", (e) => {
      this.closeWaitmodal(e);
    });
  
    document.addEventListener('click', (e) => {
      if (e.target && !e.target.closest('.waitlist-modal') && !e.target.classList.contains('quick-add-btn') && !e.target.closest('.quick-add-trigger')) {
        this.closeWaitmodal(e);
      }
    })
  }

  closeWaitmodal(e) {
		e.stopPropagation();
    this.style.display = 'none';
    
		document.documentElement.classList.remove('show-waitlist');
		if (this.form.classList.contains("success")) {
			this.form.classList.remove("success")
		}
	}
}

if (!customElements.get("waitlist-modal")) {
  customElements.define("waitlist-modal", WaitlistModal)
}
